export const tableConfig = {
    CLIENT: {
        columns: [
            {
                label: 'Client ID',
                name: 'clientId',
                options: {
                    viewColumns: false,
                },
            },
            {
                label: 'Access Token Validity',
                name: 'accessTokenValiditySeconds',
                options: {
                    viewColumns: true,
                },
            },
            {
                label: 'Refresh Token Validity',
                name: 'refreshTokenValiditySeconds',
                options: {
                    viewColumns: true,
                },
            },
            {
                label: 'Redirect URIs',
                name: 'redirectUris',
                options: {
                    viewColumns: false,
                },
            },
        ],
    },
    ROLE: {
        columns: [
            {
                label: 'Role ID',
                name: 'roleId',
                options: {
                    viewColumns: false,
                },
            },
            {
                label: 'Role Name',
                name: 'name',
                options: {
                    viewColumns: false,
                },
            },
            {
                label: 'Client',
                name: 'client',
                options: {
                    filterType: 'dropdown',
                    viewColumns: false,
                },
            },
            {
                label: 'Admin',
                name: 'admin',
                options: {
                    filterType: 'dropdown',
                },
            },
            {
                label: 'Child Roles',
                name: 'childRoles',
            },
        ],
    },
    USER: {
        columns: [
            {
                label: 'User ID',
                name: 'userId',
                options: {
                    viewColumns: false,
                },
            },
            {
                label: 'User Name',
                name: 'username',
                options: {
                    viewColumns: false,
                },
            },
            {
                label: 'Name',
                name: 'name',
                options: {
                    viewColumns: false,
                },
            },
            {
                label: 'Email',
                name: 'email',
            },
            {
                label: 'Status',
                name: 'active',
                options: {
                    filterType: 'dropdown',
                },
            },
            {
                label: 'Roles',
                name: 'roles',
            },
        ],
    },
};
